export class EvaluatorAvailabilityRequest {
    providerSK: string;
    checkDate: string;
    startTime: string;
    endTime: string;
    meetingSk: string;
    constructor(data) {
        this.providerSK = data?.providerSK;
        this.checkDate = data?.checkDate;
        this.startTime = data?.startTime;
        this.endTime = data?.endTime;
        this.meetingSk = data?.meetingSk
    }
}